import React, { useEffect, useReducer } from 'react';

// TYPES
import { RC_MAIN_FRAME_DEFAULTS, TMainFrameState } from './MainFrame.types';

// REDUX
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { getGameHistoryState, getPreloaderState, setUIState } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '@UILayer/UILayer.scss';

//PANELS & VIEWS
import { EGameStates } from '@Managers/StateManager/GameStates';
import { AgeConfirmation, GameContainer, ReconnectNotificator } from '@Modules/index';
import { MainUI, Preloader } from '@Views/index';

const MainFrame: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: TMainFrameState, newState: Partial<TMainFrameState>) => ({ ...state, ...newState }), RC_MAIN_FRAME_DEFAULTS);
    const dispatch = useAppDispatch();
    const gameStorePreloaderState = useAppSelector(getPreloaderState);
    const gameStoreGameHistoryState = useAppSelector(getGameHistoryState);

    useEffect(() => {
        EventsCenter.on(EGameStates.GAME_START, () => uiToggle(true));
        EventsCenter.on(EGameEvents.UI_TOGGLE, (data: boolean) => uiToggle(data));

        setState({
            showPreloader: gameStorePreloaderState.active
        });
    }, [gameStorePreloaderState]);

    useEffect(() => {
        let freeze = false;

        if (gameStoreGameHistoryState.isHistoryMode) freeze = true;

        dispatch(setUIState({ uiFreeze: freeze }));
    }, [gameStoreGameHistoryState]);

    function uiToggle(show: boolean) {
        dispatch(setUIState({ visible: true }));
        setState({ showUI: show });
    }

    return (
        <div className={styles.main_frame_container}>
            <AgeConfirmation />
            <ReconnectNotificator />

            <div className={styles.main_frame_game_overlay_container}>
                {state.showPreloader && <Preloader />}
                {state.showUI && <MainUI />}
            </div>

            <div className={styles.main_frame_game_container}>
                <GameContainer />
            </div>
        </div>
    );
};

export default MainFrame;
